import React, { Component, createRef } from 'react';
import { Link } from 'react-router-dom';
import {
    Button,
    Container,
    Row,
    Col,
    Collapse,
    Spinner
} from "reactstrap";
import axios from "axios";
import alertify from "alertifyjs";
import { ENDPOINT } from "../constants";
import { connect } from "react-redux";
import { updateList, updateSettings } from "../actions/photoActions";

class Home extends Component {
    constructor(props){
        super(props);

        this.state = {
            title: '',
            loading: true,
            busy: false,
            types: [],
            countries: ["United States", "Canada", "Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and/or Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Cook Islands", "Costa Rica", "Croatia (Hrvatska)", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecudaor", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "France, Metropolitan", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard and Mc Donald Islands", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran (Islamic Republic of)", "Iraq", "Ireland", "Israel", "Italy", "Ivory Coast", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, Democratic People's Republic of", "Korea, Republic of", "Kosovo", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States of", "Moldova, Republic of", "Monaco", "Mongolia", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfork Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia South Sandwich Islands", "South Sudan", "Spain", "Sri Lanka", "St. Helena", "St. Pierre and Miquelon", "Sudan", "Suriname", "Svalbarn and Jan Mayen Islands", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States minor outlying islands", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City State", "Venezuela", "Vietnam", "Virigan Islands (British)", "Virgin Islands (U.S.)", "Wallis and Futuna Islands", "Western Sahara", "Yemen", "Yugoslavia", "Zaire", "Zambia", "Zimbabwe"],
            sel_type: -1,
            sel_country: -1
        };

        this.slctCountry = createRef();
        this.slctType = createRef();
    }

    componentDidMount(){
        window.scrollTo(0, 0);
        const config = {
            dataType: "json",
            headers: {
                'content-type': 'application/json'
            },
        };

        axios.get(ENDPOINT+'/document_type', config)
        .then(response => {
            var types = response.data.document_type;
            this.setState({ types });
            this.updateCountryList(types[0].id);
        });

        axios.get(ENDPOINT+"/home_message_setting")
        .then(response => {
            this.setState({title: response.data.setting.message})
        })
    }

    updateCountryList = (type_id) => {
        localStorage.setItem('type_id', type_id)
        this.setState({ sel_type: type_id });

        const config = {
            dataType: "json",
            headers: {
                'content-type': 'application/json'
            },
        };

        axios.get(ENDPOINT+'/country?dtype=' + type_id, config)
        .then(async(response) => {
            if (response.data.message) {
                alertify.error(response.data.message);
                this.setState({ loading: false, countries: []});
                return;
            }
            
            var countries = response.data.country;
            this.setState({
                loading: false,
                countries
            });
            if (countries.length > 0)
            {
                var country = countries.find(c => c.nicename == 'United States');
                country = country || countries[0];
                this.setState({ sel_country: country.nicename+'-'+country.id+'-'+country.shipping_price+'-'+country.size })
            }
        })
        .catch((error) => {
            console.log(error);
            alertify.error(error.message);
        });
    }
    
    handleTypeSelect = () => {
        var type_id = this.slctType.current.value;
        this.updateCountryList(type_id);
    }

    handleCountrySelect = () =>{
        var pieces = this.slctCountry.current.value.split("-");
        this.setState({ sel_country: this.slctCountry.current.value });
        // localStorage.setItem("country", pieces[0]);
        // localStorage.setItem("country_id", pieces[1]);
    }

    handleGetPhotos = () => {
        var pieces = this.slctCountry.current.value.split("-");
        localStorage.setItem("country", pieces[0]);
        localStorage.setItem("country_id", this.slctCountry.current.value);

        var data = {
            country: pieces[0],
            country_id: pieces[1],
            shipping_price: pieces[2],
            size: pieces[3]
        };

        this.props.updateSettings(data);

        // this.props.history.push("/steps");
        document.getElementById('file-select').click();
    }

    onFilesSelected = (e) => {
        var self = this;
        var files = e.target.files;
        document.getElementById('button1').disabled = true;
        this.setState({ busy: true });

        var image_base64;
        var reader = new FileReader(); 
        reader.onload = (re) => {
            var arr = [];
            image_base64 = re.target.result;
            var quantity = 2;
            
            var item = {
                base_sixty_four: image_base64,
                quantity: quantity
            };
            arr.push(item);
            self.setState({ busy: false });
            document.getElementById('button1').disabled = false;
            self.props.updateList(arr);
            self.props.history.push("/order-summary");
        };

        reader.readAsDataURL(files[0]);
        document.getElementById('file-select').value = null;
    }

    render() {
        return (
            <div className="home">
                {this.state.loading? <div style={{height: '100vh'}}><div className="loading"></div></div> : 
                    <div className="root">
                    <div className="main">
                        <div className="top_sec">
                            <div className="text">
                                <h1 className="header_top">{this.state.title}</h1>
                                {/* <div className="header_line"></div> */}
                                <h2 className="header_bottom">Select Document Type:</h2>
                            </div>
                            <div className="drop_down_container">
                                <div className="drop_down">
                                    {/* <button onClick={this.handleCountrySelect} className="drop_down_img">United States</button> */}
                                    <select className="drop_down_img type-slct" ref={this.slctType} onChange={this.handleTypeSelect}
                                    value={this.state.sel_type}>
                                        {this.state.types.map(function(type, key){
                                            return(
                                                <option key={key} value={type.id} >
                                                    {type.name}
                                                </option>
                                            );
                                        },this)}
                                    </select>
                                    <div className='after'></div>
                                    <div className="scrollable-menu"></div>
                                </div>
                            </div>
                            <div className="text">
                                <h2 className="header_bottom">Select Country:</h2>
                            </div>
                            <div className="drop_down_container">
                                <div className="drop_down">
                                    {/* <button onClick={this.handleCountrySelect} className="drop_down_img">United States</button> */}
                                    <select className="drop_down_img countries-slct" ref={this.slctCountry} onChange={this.handleCountrySelect}
                                    value={this.state.sel_country}>
                                        {this.state.countries.map(function(country, key){
                                            return(
                                                <option key={key} value={country.nicename+'-'+country.id+'-'+country.shipping_price+'-'+country.size}>
                                                    {country.nicename}
                                                </option>
                                            );
                                        },this)}
                                    </select>
                                    <div className='after'></div>
                                    <div className="scrollable-menu"></div>
                                </div>
                            </div>
                            {/* <Link to="/" className="photo_img" id="button1">Get My Photos</Link> */}
                            <button onClick={this.handleGetPhotos} className="photo_img" id="button1" disabled={this.state.countries.length == 0}>
                            {
                                this.state.busy ? 
                                <Spinner />
                                :
                                'Get My Photos'
                            }
                            </button>
                            <input id="file-select" className="input-file" type="file" onChange={this.onFilesSelected} accept=".jpg, .jpeg, .png, .gif" />
                            </div>
                            <div className="middle_sec">
                                <div className="money_logo">Save Money</div>
                                <div className="time_logo">Save Time</div>
                                <div className="travel_logo">Travel Anywhere</div>
                            </div>
                            <div className="lowerTop">
                                <div className="box_steps">
                                    <h3>Just 3 easy steps</h3>
                                    <div className="step1">
                                        <h4>Photo</h4>
                                        <p>Take a photo with your<br />phone or a camera<br /><span>Step 1</span></p>
                                    </div>
                                    <div className="step2">
                                        <h4>Upload</h4>
                                        <p>Upload your photos<br />fast and easy<br /><span>Step 2</span></p>
                                    </div>
                                    <div className="step3">
                                        <h4>Mail</h4>
                                        <p>Have your photos sent to<br />your preferred address<br /><span>Step 3</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}
const mapStateToProps = (state, ownProps) =>{
    return {
        ...state
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
        updateSettings: (data) =>{dispatch(updateSettings(data))},
        updateList: (data) =>{dispatch(updateList(data))}        
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Home);